import React, { useEffect, useState, useRef } from 'react';
import { dashAPI, productAPI, orderAPI, returnAPI, walletAPI, dealAPI, profileAPI, notifAPI } from './SellerApi';


export const SellerReturns = () => {
  const [returns, setReturns] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    returnAPI.list().then(r => setReturns(r.data || [])).catch(() => setReturns([
      { id:'RET-01', order_id:'ATR-9900', product_name:'Organic Potato', customer_name:'Anbu S.', reason:'Damaged in transit', status:'pending', created_at:'2026-04-10', refund_amount:32 },
    ])).finally(() => setLoading(false));
  }, []);

  const handle = async (id, action) => {
    try {
      await returnAPI.action(id, action);
      setReturns(r => r.map(x => x.id===id ? {...x, status: action==='approve' ? 'approved':'rejected'} : x));
    } catch (err) { alert(err.message); }
  };

  return (
    <div className="sp-card">
      <div className="sp-card-title">Return Requests</div>
      {loading ? <div className="sp-skeleton" style={{height:200}} /> : (
        <div className="sp-table-wrap">
          <table className="sp-table">
            <thead><tr><th>Return ID</th><th>Order ID</th><th>Product</th><th>Customer</th><th>Reason</th><th>Refund</th><th>Status</th><th>Actions</th></tr></thead>
            <tbody>
              {returns.map(r => (
                <tr key={r.id}>
                  <td className="td-hi">#{r.id}</td>
                  <td>#{r.order_id}</td>
                  <td>{r.product_name}</td>
                  <td>{r.customer_name}</td>
                  <td style={{maxWidth:180,fontSize:12}}>{r.reason}</td>
                  <td className="td-gold">₹{r.refund_amount}</td>
                  <td><span className={`sp-badge ${r.status==='approved'?'delivered':r.status==='rejected'?'cancelled':'pending'}`}>{r.status}</span></td>
                  <td>
                    {r.status === 'pending' && (
                      <div style={{display:'flex',gap:'0.4rem'}}>
                        <button className="sp-btn-primary" style={{padding:'4px 10px',fontSize:11}} onClick={() => handle(r.id,'approve')}>Approve</button>
                        <button className="sp-btn-danger"  style={{padding:'4px 10px',fontSize:11}} onClick={() => handle(r.id,'reject')}>Reject</button>
                      </div>
                    )}
                  </td>
                </tr>
              ))}
              {returns.length === 0 && <tr><td colSpan={8} style={{textAlign:'center',color:'var(--t3)',padding:'2rem'}}>No return requests</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
export default SellerReturns;